/// This function is for checking if a date is within a day range
/// Dates have times associated with them, so this function ignores that
export function isWithinDayRangeInclusive({ date, start, end }: { date: Date; start: Date; end: Date }): boolean {
    start = new Date(start);
    start.setHours(0, 0, 0, 0);
    end = new Date(end);
    end.setHours(23, 59, 59, 999);

    return date >= start && date <= end;
}
